const actionTypes = {
    saveSupplier: 'saveSupplier',
    saveSuppliers: 'saveSuppliers',
    viewOrder: 'viewOrder',
    updateOrder: 'updateOrder',
    viewProduct: 'viewProduct',
    searchProduct: 'searchProduct',
    setShopDomain: 'setShopDomain',
    setShopId: 'setShopId',
    saveCurrency: 'saveCurrency',
    setShopData: 'setShopData',
    setFetchingData: 'setFetchingData',
    savePurchaseOrders: 'savePurchaseOrders',
    saveSummaryOrders: 'saveSummaryOrders',
    receiveQty: 'receiveQty',
    changeFetchingPos: 'changeFetchingPos',
    setReplacedProduct: 'setReplacedProduct',
}

export default actionTypes